import { Interpolation } from '@emotion/react';
import { Button, Theme, useTheme } from '@mui/material';
import { FC, PropsWithChildren, ReactElement, ReactEventHandler } from 'react';

type ContactUsButtonProps =
    | {
          icon: ReactElement;
          href: string;
          newTab?: boolean;
          onClick?: never;
      }
    | {
          icon: ReactElement;
          href?: never;
          newTab?: never;
          onClick: ReactEventHandler;
      };

export const ContactUsButton: FC<PropsWithChildren<ContactUsButtonProps>> = (props) => {
    const theme = useTheme();
    const cssOverrides: Interpolation<Theme> = {
        width: '100%',
        borderRadius: 0,
        margin: 0,
        padding: '12px',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${theme.palette.grey[600]}`,
        fontSize: theme.typography.body2.fontSize,
        color: theme.palette.grey[800],
        textAlign: 'center',
        '&:hover': {
            border: `1px solid ${theme.palette.grey[900]}`,
            color: theme.palette.grey[900],
            backgroundColor: theme.palette.grey[200],
        },
        height: '100%',
    };

    if (props.href) {
        const { children, icon, href, newTab = false } = props;

        return (
            <Button
                startIcon={icon}
                href={href}
                css={cssOverrides}
                {...(newTab && { target: '_blank', rel: 'noopener noreferrer' })}
            >
                {children}
            </Button>
        );
    }

    return (
        <Button startIcon={props.icon} onClick={props.onClick} css={cssOverrides}>
            {props.children}
        </Button>
    );
};
